import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';



@Component({
  selector: 'app-nica-form-toolbar',
  templateUrl: './nica-form-toolbar.component.html',
  styleUrls: ['./nica-form-toolbar.component.css']
})
export class NicaFormToolbarComponent implements OnInit {




  newPulsanti: any[];
  chosenButton: any[];

  show = false;


  constructor() {
   

  }



  @Output() eventi: EventEmitter<any> = new EventEmitter<any>();

  @Input() titoloToolbar?: string;

  @Input() element: string;

  @Input() pulsantiDaAttivare?: Array<any>=[];

  @Input() idHelper?: number;

  @Input() cmHelper: string = "";




  ngOnInit(): void {

    const newPulsanti = [
      { text: 'close', icon: 'mdi mdi-close', visible: true, hint: 'Chiudi scheda', id: 0, class: "button-trasparent", stylingMode: "outlined", action: 'close' },
      { text: 'forward', icon: 'mdi mdi-keyboard-return', visible: true, image: '', hint: 'Azioni', id: 1, class: "button-trasparent", stylingMode: "outlined", action: 'return' },
      { text: 'help', icon: 'mdi mdi-help-box', visible: true, image: '', hint: 'Chiedi Aiuto', id: 2, class: "button-trasparent", stylingMode: "outlined", action: 'help' },
      { text: 'minimize', icon: 'mdi mdi-window-minimize', visible: true, image: '', hint: 'Riduci ad icona', id: 3, class: "button-trasparent", stylingMode: "outlined", action: 'minimize' },
      { text: 'maximize', icon: 'mdi mdi-arrange-bring-forward', visible: true, image: '', hint: 'Ingrandisci', id: 4, class: "button-trasparent", stylingMode: "outlined", action: 'maximize' },
    ];

    this.newPulsanti = this.pulsantiDaAttivare.map((res, c) => {
      console.log(res)

      let cio = newPulsanti.findIndex(item => item.id === res)

      return newPulsanti[cio]


    })






  }

  ngAfterViewInit() {
    /* document.getElementById(this.element).addEventListener('mousedown', mouseDown, false);
     window.addEventListener('mouseup', mouseUp, false);
 
     function mouseUp()
     {
         window.removeEventListener('mousemove', divMove, true);
     }
     function mouseDown(e){
       window.addEventListener('mousemove', divMove, true);
     }
     
     function divMove(e){
       var div = document.getElementById('dynamic-content');
       div.style.position = 'absolute';
       div.style.top = e.clientY + 'px';
       div.style.left = e.clientX + 'px';
     }*/
  }

  clickButton(evt) {

    console.log("ecco ", evt)
    if (evt == 'minimize') {

      var el = document.getElementById(this.element);

      var toobarHeigth = document.getElementById('formToolbar').offsetHeight

      el.style.height = toobarHeigth + 'px'
      el.style.bottom = toobarHeigth + 'px'

      el.classList.remove('slide-top')
      el.classList.add('slide-bottom')

      return
    }
    if (evt == 'maximize') {

      if (typeof this.element != 'undefined') {
        var el = document.getElementById(this.element);
        el.style.height = ''
        el.style.bottom = ''

        if (!el.classList.contains('slide-top-min') && !el.classList.contains('slide-bottom')) {
          el.classList.add('slide-top-min');
          return
        }


        if (el.classList.contains('slide-bottom')) {
          el.classList.add('slide-top')
          el.classList.remove('slide-bottom')
          return
        }

        if (el.classList.contains('slide-top-min')) {
          el.classList.remove('slide-top-min');
          return
        }

      } else {
        this.eventi.emit(evt)
      }


    }

    if (evt == 'close') {
      this.eventi.emit(evt)
      return
    }


  }
  maximizing(e) {
    if (typeof this.element != 'undefined'){
      var el = document.getElementById(this.element);
      el.style.height = ''
      el.style.bottom = ''
      if (el.classList.contains('slide-bottom')) {
        el.classList.add('slide-top')
        el.classList.remove('slide-bottom')

      } else {
        return
      }
    }
  }

}
